import apiWrapper from '../apiWrapprer'

const endpoints = {
  getUnsubscriptionCounter: '/frontend/webMethods/Statistics.asmx/GetUnsubscriptionCounter',
  getRecipientEmail: '/frontend/webMethods/Statistics.asmx/GetRecipientEmail',
  getGroups: '/frontend/webMethods/Statistics.asmx/GetGroups',
  getGroupDetails: '/frontend/webMethods/Statistics.asmx/GetGroupDetails'
}

export const getUnsubscriptionCounter = (idList, guid, idMessage, optOutType, dateFromUTC, dateToUTC) => {
  const url = endpoints.getUnsubscriptionCounter
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage,
      optOutType,
      dateFromUTC,
      dateToUTC
    })
  }).then(extractData)
}

export const getRecipientEmail = (idList, guid, idRecipient) => {
  const url = endpoints.getRecipientEmail
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, idRecipient
    })
  }).then(extractData)
}

export const getGroups = (idList, guid, search, pageSize, pageNumber, orderBy, orderDescending) => {
  const url = endpoints.getGroups
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, search, pageSize, pageNumber, orderBy, orderDescending
    })
  }).then(extractData)
}

export const getGroupDetails = (idList, guid, idGroup) => {
  const url = endpoints.getGroupDetails
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, idGroup
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
